// import './App.css';
import React, { useState } from "react";

import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  HStack,
  Spinner,
  Text,
} from "@chakra-ui/react";
import Strings from "../config/Strings";

function ClosePlexiMailAlert({ disclosure }) {
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setLoading] = useState(false);
  return (
    <AlertDialog
      isOpen={disclosure.isOpen}
      onClose={disclosure.onClose}
      closeOnOverlayClick={false}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
          {Strings.app.dialog.delete_account.title}
          </AlertDialogHeader>

          <AlertDialogBody>
            <Text>{Strings.app.dialog.delete_account.description}</Text>
            {isLoading && <HStack><Spinner size={"sm"} /> <Text>{Strings.app.dialog.delete_account.deleting}</Text></HStack>}
            {errorMessage && <Text color={"red"}>{`${errorMessage}. ${Strings.app.dialog.delete_account.please_try_again_later}`}</Text>}
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button
              colorScheme={"gray"}
              mr={4}
              onClick={() => {
                disclosure.onClose();
              }}
            >
              {Strings.app.dialog.delete_account.cancel}
            </Button>
            <Button
              colorScheme={"red"}
              isLoading={isLoading}
              onClick={() => {
                setErrorMessage(null);
                setLoading(true);
                window.wallet.getCryptonName().then(name => {
                  return window.plexiMailService.deleteCrypton(name);
                }).then(() => {
                  return window.plexiMailService.closeAccount()
                }).then((res) => {
                  if (!res) {
                    throw new Error(Strings.app.dialog.delete_account.failed_to_delete);
                  }
                  return window.mailService.reset();
                }).then(() => {
                  return window.wallet.reset();
                }).then(() => {
                  setLoading(false);
                  window.forceQuit = true;
                  setTimeout(function () {
                    window.location.reload(true);
                  });
                }).catch(e => {
                  console.error(e);
                  setLoading(false);
                  setErrorMessage(e.message || e.msg || e);
                })
              }}
            >
              {Strings.app.dialog.delete_account.delete}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
export default ClosePlexiMailAlert;
